/**
 * Dev/staging-only helpers to pre-fill agent registration (no business logic).
 * Shown only on localhost or staging hostnames — never on production hotelsriver.com.
 */

import { FormFields } from "../contexts/RegistrationContext";

/** @returns {boolean} */
export function isAgentRegistrationTestFillAvailable() {
  if (typeof window === "undefined") return false;
  const h = String(window.location.hostname || "").toLowerCase();
  if (import.meta.env.DEV) return true;
  if (h === "localhost" || h === "127.0.0.1") return true;
  if (h.endsWith(".local")) return true;
  if (h.includes("staging")) return true;
  return false;
}

/**
 * Partial formData patch: all required registration fields with demo values.
 * Password matches Hyp-style test expectations; email is unique per click.
 */
export function getAgentRegistrationTestFormPatch() {
  const ts = Date.now();
  return {
    [FormFields.PERSONAL_INFO.FIRST_NAME]: "בדיקה",
    [FormFields.PERSONAL_INFO.LAST_NAME]: "אוטומטית",
    [FormFields.PERSONAL_INFO.NATIONAL_ID]: "000000000",
    [FormFields.PERSONAL_INFO.EMAIL]: `test+${ts}@example.com`,
    [FormFields.PERSONAL_INFO.CELL]: "0559999333",
    [FormFields.PERSONAL_INFO.COUNTRY]: "Israel",
    [FormFields.ACCOUNT_INFO.PASSWORD]: "Test1234!",
    [FormFields.ACCOUNT_INFO.PASSWORD_AGAIN]: "Test1234!",
    [FormFields.COMPANY_INFO.COMPANY_COUNTRY]: "Israel",
    [FormFields.COMPANY_INFO.COMPANY_NAME]: "עסק בדיקה אוטומטית",
    [FormFields.COMPANY_INFO.COMPANY_NUMBER]: "555555555",
    [FormFields.COMPANY_INFO.COMPANY_TYPE]: "פטור",
    [FormFields.COMPANY_INFO.IN_BUSINESS]: true,
    [FormFields.COMPANY_INFO.SALES_REVENUE]: {
      name: "0 - 500,000 $",
      value: "0-500,000 $",
    },
    [FormFields.ADDITIONAL_INFO.PACKAGE]: "PRO",
    [FormFields.ADDITIONAL_INFO.RECOMMENDED_BY]: "",
    [FormFields.OTHERS.TERMS_APPROVED]: true,
  };
}
